<template>
  <div class="overlay center">
    <div class="modal reset">
      <figure class="center">
        <svg
          class="pauseIconBig"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM8.33333 8.77778C8.33333 8.22549 8.78105 7.77778 9.33333 7.77778H10C10.5523 7.77778 11 8.22549 11 8.77778V15C11 15.5523 10.5523 16 10 16H9.33333C8.78105 16 8.33333 15.5523 8.33333 15V8.77778ZM13.7778 7.77778C13.2255 7.77778 12.7778 8.22549 12.7778 8.77778V15C12.7778 15.5523 13.2255 16 13.7778 16H14.4444C14.9967 16 15.4444 15.5523 15.4444 15V8.77778C15.4444 8.22549 14.9967 7.77778 14.4444 7.77778H13.7778Z"
            fill="#F9973D"
          />
        </svg>
      </figure>
      <h2>Game Pause</h2>
      <span>This way nobody will die while the game is on pause.</span>

      <div class="autoPause">
        <div class="desc">
          <p :class="$store.state.autoPause ? 'green' : 'red'">
            Auto-Pause: {{ autoPauseState }}
          </p>
          <span>Automatically pause wtime hile you are not playing</span>
        </div>

        <!-- Switch -->
        <label class="switch">
          <input
            type="checkbox"
            v-model="$store.state.autoPause"
            @click="autoPause"
          />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="buttons">
        <div class="button" @click="resume">Resume</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GamePause",
  components: {},
  props: {},
  emits: ["close"],
  data() {
    return {};
  },

  computed: {
    autoPauseState: function() {
      return this.$store.state.autoPause ? "On" : "Off";
    },
  },

  mounted: function() {
    this.track("GAME PAUSE", "GAME PAUSE");
    setTimeout(() => {
      this.opened = true;
    }, 100);
  },
  unmounted: function() {},

  methods: {
    autoPause: function() {
      this.track(
        "AUTO PAUSE",
        "AUTO PAUSE",
        "auto pause " + this.$store.state.autoPause
      );
      this.$store.commit("setAutopause", !this.$store.state.autoPause);
    },
    resume: function() {
      this.track("GAME RESUME", "GAME RESUME");
      this.$store.commit("startTick");
      this.$emit("close");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.overlay {
  position: fixed;
  z-index: 9999;
  .modal {
    border-radius: 12px;
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    min-width: 300px;

    p {
      font-weight: 600;
      color: $black;
    }

    .ghost {
      color: $black;
    }

    input {
      font-size: 24px;
      text-align: center;
      max-width: 120px;
      border-radius: 6px;
      margin-bottom: 24px;
    }

    .button {
      width: 100%;
      margin: 8px;
    }
  }

  .reset {
    figure {
      width: 96px;
      height: 96px;
      margin-bottom: 0;

      svg {
        width: 100%;
        height: 100%;
        margin-bottom: 0;
      }
    }
  }

  .autoPause {
    width: 100%;
    display: flex;
    border-top: 1px solid $gray300;
    border-bottom: 1px solid $gray300;
    padding: 16px 0;
    margin-top: 16px;
    .desc {
      text-align: left;
      margin: 0 16px;
      p {
        font-size: 18px;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 8px;
      }

      span {
        color: $gray800;
      }
    }

    .green {
      color: green;
    }

    .red {
      color: $red;
    }
  }

  /* The slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 80px;
    height: 34px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: $blue;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px$blue;
  }

  input:checked + .slider:before {
    // transform: translateX(26px);
    left: auto;
    right: 4px;
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
}
</style>
